const baseURL = 'https://pendientes.faugetdigital.shop/';

export default baseURL;
